import i18n from './i18n';

export { i18n };
